import React, { useState } from 'react';
import { Send, Copy, Check } from 'react-feather';
import {
  InlineShell,
  InlineEyebrow,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

function DraftBlock({
  text,
  label,
  isMain,
  recipientId,
  onAction,
}: {
  text: string;
  label?: string;
  isMain?: boolean;
  recipientId?: string;
  onAction?: OnAction;
}) {
  const [sent, setSent] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleSend = async () => {
    if (!recipientId) return;
    onAction?.({
      action: 'cloud_function',
      params: {
        functionName: 'sendUserChatMessageEurW',
        args: { recipientId, message: text },
      },
    });
    setSent(true);
  };

  const handleCopy = () => {
    onAction?.({ action: 'clipboard', params: { text } });
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={`f8c-draft-block${isMain ? ' f8c-draft-block-main' : ''}`}>
      {label && <div className="f8c-draft-label">{label}</div>}
      <p className={`f8c-draft-text${isMain ? '' : ' f8c-draft-text-alt'}`}>{text}</p>
      <div className="f8c-draft-actions">
        {recipientId && (
          <CardButton primary small onClick={handleSend} disabled={sent}>
            {sent ? <><Check size={12} /> Sent</> : <><Send size={12} /> Send</>}
          </CardButton>
        )}
        <CardButton small onClick={handleCopy}>
          {copied ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
        </CardButton>
      </div>
    </div>
  );
}

export default function MessageDraftCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const recipientName: string | undefined = data.recipientName;
  const recipientId: string | undefined = data.recipientId;
  const mainDraft: string = data.mainDraft || data.draft || '';
  const alternatives: string[] = Array.isArray(data.alternatives) ? data.alternatives : [];

  return (
    <InlineShell>
      <InlineEyebrow label={`draft${recipientName ? ` · ${recipientName}` : ''}`} />

      <div className="f8c-draft-stack">
        {mainDraft && (
          <DraftBlock text={mainDraft} isMain recipientId={recipientId} onAction={onAction} />
        )}
        {alternatives.map((alt, i) => (
          <DraftBlock
            key={i}
            text={alt}
            label={`option ${i + 2}`}
            recipientId={recipientId}
            onAction={onAction}
          />
        ))}
      </div>
    </InlineShell>
  );
}
